import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from '~/App'
import { ToastProvider } from '~/components/ui/toast'
import { initTheme } from '~/lib/theme'
import '~/app.css'

// 저장된 라이트/다크 테마를 첫 렌더 전에 적용한다(깜빡임 방지).
initTheme()

// SPA는 /admin 베이스에서 동작한다. BrowserRouter basename을 base와 일치시킨다.
const root = document.getElementById('root')
if (!root) {
    throw new Error('#root 엘리먼트를 찾을 수 없어요.')
}

createRoot(root).render(
    <StrictMode>
        <ToastProvider>
            <BrowserRouter basename='/admin'>
                <App />
            </BrowserRouter>
        </ToastProvider>
    </StrictMode>
)
